"use strict";

import cookieconsent from 'cookieconsent';

export default function initCookieNotice() {

  let rootNode = document.querySelector('html');

  if (rootNode.classList.contains('no-cookie-consent')) {
    rootNode.classList.remove('no-cookie-consent');
    return;
  }

  window.cookieconsent.initialise({
    revokable:false ,
    law: {
      regionalLaw: false,
    },
    location: false,
    content: {
      message: 'Diese Website verwendet Cookies. Wenn Sie auf dieser Website surfen, stimmen Sie der Verwendung von Cookies zu. ',
      dismiss: 'Weiter',
      link: 'Weitere Informationen erhalten Sie hier',
      href: '/datenschutz',
    },
    elements: {
      message: '<span id="cookieconsent:desc" class="cc-message ">{{message}}</span>',
      messagelink: '<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="{{href}}" target="_blank">{{link}}</a></span>',
      dismiss: '<a aria-label="dismiss cookie message" tabindex="0" class="cc-btn cc-dismiss button button-primary">{{dismiss}}</a>',
      allow: '<a aria-label="allow cookies" tabindex="0" class="cc-btn cc-allow">{{allow}}</a>',
      deny: '<a aria-label="deny cookies" tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',
      link: '<a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="{{href}}" target="_blank">{{link}}</a>',
      close: '<span aria-label="dismiss cookie message" tabindex="0" class="cc-close">{{close}}</span>',
    },
    layout: 'ke-cookie',
    layouts: {
      'ke-cookie': '<div class="cookie-notice">{{messagelink}} {{dismiss}}</div>',
    },
  });
}



// WEBPACK FOOTER //
// ./components/cookienotice.js